/**
 * Minimal ABI for Silo V2 (and V3 — identical shape) InterestRateModelV2.
 *
 * Only `getConfig(silo)` is needed for reserve-data rate derivation.
 * Keeping this local avoids pulling in the full `@1delta/irm-sdk` just
 * for a single ABI entry.
 */
export const InterestRateModelV2Abi = [
  {
    type: 'function',
    name: 'getConfig',
    stateMutability: 'view',
    inputs: [{ name: '_silo', type: 'address' }],
    outputs: [
      {
        name: '',
        type: 'tuple',
        components: [
          { name: 'uopt', type: 'int256' },
          { name: 'ucrit', type: 'int256' },
          { name: 'ulow', type: 'int256' },
          { name: 'klin', type: 'int256' },
          { name: 'ki', type: 'int256' },
          { name: 'kcrit', type: 'int256' },
          { name: 'klow', type: 'int256' },
          { name: 'beta', type: 'int256' },
          { name: 'ri', type: 'int256' },
          { name: 'Tcrit', type: 'int256' },
        ],
      },
    ],
  },
] as const
